import { gql } from "@apollo/client";

// Venue fragments
export const VENUE_FRAGMENT = gql`
  fragment VenueFields on Venue {
    id
    name
    description
    address
    latitude
    longitude
    type
    createdAt
    updatedAt
  }
`;

// Queries
export const LIST_VENUES = gql`
  query ListVenues($filter: VenueFilterInput, $limit: Int, $nextToken: String) {
    listVenues(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        ...VenueFields
      }
      nextToken
      total
    }
  }
  ${VENUE_FRAGMENT}
`;

export const SEARCH_VENUES = gql`
  query SearchVenues($query: String!, $limit: Int) {
    searchVenues(query: $query, limit: $limit) {
      items {
        ...VenueFields
      }
      total
    }
  }
  ${VENUE_FRAGMENT}
`;

export const GET_VENUE = gql`
  query GetVenue($id: ID!) {
    getVenue(id: $id) {
      ...VenueFields
    }
  }
  ${VENUE_FRAGMENT}
`;

// Mutations
export const CREATE_VENUE = gql`
  mutation CreateVenue($input: CreateVenueInput!) {
    createVenue(input: $input) {
      ...VenueFields
    }
  }
  ${VENUE_FRAGMENT}
`;

export const UPDATE_VENUE = gql`
  mutation UpdateVenue($id: ID!, $input: UpdateVenueInput!) {
    updateVenue(id: $id, input: $input) {
      ...VenueFields
    }
  }
  ${VENUE_FRAGMENT}
`;

export const DELETE_VENUE = gql`
  mutation DeleteVenue($id: ID!) {
    deleteVenue(id: $id)
  }
`;
